export default "__VITE_ASSET__2b64a234__"